import Auth from "@okta/okta-vue";
import Vue from "vue";
import Axios from "axios";

// Todo: find (yet another) fix for
// https://github.com/okta/okta-oidc-js/issues/460

Vue.use(Auth, {
    issuer: `https://${process.env.VUE_APP_OKTA_DOMAIN}/oauth2/default`,
    clientId: process.env.VUE_APP_OKTA_CLIENT_ID,
    redirectUri: `${location.origin}/okta-callback`,
    scopes: ["openid", "profile", "admin"],
    pkce: true,
});

// @ts-ignore (For debug purposes)
// window.$auth = Vue.prototype.$auth;

Axios.interceptors.request.use(
    async function (config) {
        // Do something before request is sent
        // Add our Okta JWT for requests to the CIAO API
        // config.headers.
        if (!config.url.startsWith(process.env.VUE_APP_API_BASE)) return config;

        if (!config.headers) config.headers = {};
        config.headers.authorization = `bearer ${await Vue.prototype.$auth.getAccessToken()}`;

        return config;
    },
    function (error) {
        // Do something with request error
        return Promise.reject(error);
    },
);

declare module "vue/types/vue" {
    interface Vue {
        $auth: any;
    }
}

export const OktaAxios = Axios.create({
    baseURL: `https://${process.env.VUE_APP_OKTA_DOMAIN}/api/v1`,
    withCredentials: true,
});

OktaAxios.interceptors.request.use(
    async function (config) {
        if (!config.headers) config.headers = {};
        config.headers.authorization = `bearer ${await Vue.prototype.$auth.getAccessToken()}`;
        return config;
    },
    function (error) {
        // Do something with request error
        return Promise.reject(error);
    },
);
